import { Module } from 'vuex';

import { NavState } from './types';
import { StoreState } from '@/types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state: NavState = {
  state: '',

  dialogs: {
    editAccount: false,
  },
};

const module: Module<NavState, StoreState> = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default module;
